<template>
  <div :class="['quick-order-card', html ? 'has-html' : '']" v-if="showQuickOrderCard">
    <div class="xml-card" ref="quickCard" v-html="html"></div>
    <div v-if="errorToast" class="toast-ec-card-error">{{ toastMsg }}</div>
  </div>
</template>

<script>
import { translateXMLToVirtualDOM, parseMsgXML, parseMsgContent } from '@/components/message-items/MsgQdxml/xmlParser/transfer';
import { bindXMLEvent } from '@/components/message-items/MsgQdxml/xmlParser/bindXMLEvent';
import { renderNode } from '@/components/message-items/MsgQdxml/xmlParser/render';
import { GET_QUICK_ORDER_CARD } from '@/utils/api';
import authAjax from '@/utils/authajax';
import qs from 'qs';

export default {
  name: 'QuickOrderCard',
  props: {
    sessionStart: {
      type: Boolean,
      default: false,
    },
    wpaDetail: {
      type: Object,
      default: () => ({}),
    },
    authConf: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      scene: null,
      sceneArgs: null,
      // 用户手动关闭了卡片
      userClosed: false,
      // 是否已经请求过卡片
      hasRequested: false,
      toastMsg: '',
      errorToast: false,
      toastTimer: null,
      html: '',
    };
  },
  computed: {
    showQuickOrderCard() {
      return Boolean(this.scene) && !this.userClosed;
    },
    kfuin() {
      return this.wpaDetail.kfuin || '';
    },
    secretKey() {
      return this.wpaDetail.token || '';
    },
    visitorId() {
      return this.wpaDetail.visitorid || '';
    },
    channelType() {
      // webim 固定为4，由于webim sdk并没有开放方法出来获取通路类型，所以这里先写死
      return 4;
    },
  },
  watch: {
    sessionStart: {
      handler(isSessionStart) {
        // 进线以后所有参数才备齐，才能请求接口
        if (!this.showQuickOrderCard || this.hasRequested || !isSessionStart) {
          return;
        }

        // 如果没有实名就不用拉取电商请求
        if (!this.authConf.authType) {
          // 如果没有实名，就直接关闭该功能
          this.userClosed = true;
          return;
        }

        // 标记已经请求过一次接口，后面watch变化不再请求
        this.hasRequested = true;

        this.getQuickOrderCard();
      },
      immediate: true,
    },
  },
  created() {
    this.getUrlSceneParams();
  },
  methods: {
    getUrlSceneParams() {
      const urlParams = qs.parse(window.location.search, { ignoreQueryPrefix: true });
      const { scene, sceneArgs } = urlParams;
      this.scene = Number(scene) || null;
      this.sceneArgs = sceneArgs || null;
    },
    showToast(msg = '该功能不可用') {
      this.toastMsg = msg;
      this.errorToast = true;

      // 2.5s后隐藏toast
      if (this.toastTimer) clearTimeout(this.toastTimer);
      this.toastTimer = setTimeout(() => {
        this.errorToast = false;
        this.toastMsg = '';
        this.toastTimer = null;

        // 如果报错了的话，就直接模拟关闭卡片
        this.userClosed = true;
      }, 2500);
    },
    getQuickOrderCard() {
      const params = {
        scene: this.scene,
        sceneArgs: this.sceneArgs,
        channelType: this.channelType,
      };

      authAjax.post(`${GET_QUICK_ORDER_CARD}?kfuin=${this.kfuin}`, params)
        .then((res) => {
          const { code, message, data } = res.data;

          const SUCCESS_CODE = 0;
          if (code !== SUCCESS_CODE) {
            throw Object.assign(new Error(message), { code });
          }

          const { xmlCard, xmlMsg } = data;
          const [xmlStr, scriptStr] = parseMsgContent(xmlCard);
          const xmlDom = parseMsgXML(xmlStr);
          const vDom = translateXMLToVirtualDOM(xmlDom);
          const html = renderNode(vDom);
          this.html = html;
          this.$nextTick(() => {
          // 绑定xml事件
            bindXMLEvent(this.$refs.quickCard, vDom, scriptStr, {
              __onlineGoodsObj: {
                scene: this.scene,
                sceneArgs: this.sceneArgs,
                channelType: 4, // webim 写死
                infoUrl: GET_QUICK_ORDER_CARD,
                tempXml: xmlMsg,
              },
            });

            // 特别地绑定一个点击卡片本身任意地方就关闭卡片的事件
            this.$refs.quickCard.firstElementChild.addEventListener('click', () => {
              this.userClosed = true;
            });
          });
        })
        .catch(({ code, message }) => {
          // 弹一个功能不可用的toast，我也不知道这状态码是啥
          if ([62005, 62006].includes(code)) {
            this.showToast();
            return;
          }

          // 这里接口出错了，但是之前的代码没有定义如何提示用户，因此这里直接手动关闭快捷卡片，并且弹toast
          this.showToast(message);
        });
    },
  },
};
</script>

<style lang="less">
.webim-aio-pc,
.webim-aio-h5 {
  .quick-order-card {
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    background: rgba(248, 249, 251, 0.7);

    &.has-html {
      padding: 10px 20px;
    }

    .msg-xml-container {
      display: block;
      width: 100%;
      color: #000;
      box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
      border-radius: 6px;
      line-height: 1.4285;
      margin-top: 2px;
    }

    .toast-ec-card-error {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      padding: 0 8px;
      line-height: 26px;
      text-align: center;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      color: #fff;
      border-radius: 5px;
      background-color: rgba(0, 0, 0, 0.44);
    }
  }
}

.webim-aio-pc .quick-order-card .xml-card {
  width: 330px;
}

.webim-aio-h5 .quick-order-card .xml-card {
  width: 100%;
}
</style>
